import * as _ from 'lodash';
import { getLogger } from '../diagnostics/logger';
import moment from 'moment';
import {
  LOAD_MVNO_TEMPLATES_FAILURE,
  LOAD_MVNO_TEMPLATES_PENDING,
  LOAD_MVNO_TEMPLATES_SUCCESS,
} from '../actions/actionTypes';
import { MvnoTemplate } from '../api/mvnoTemplateApi';
import { DropdownItem } from '../components/ui/input/DropdownInput';
import { SimManagementError } from '../models/Errors';
import { initialAppState } from '../models/state/appState';
import { MvnoTemplatesCacheTimeout } from '../models/state/simProvision/cacheTimeouts';
import { MvnoTemplatesState } from '../models/state/simProvision/simProvisionState';
const log = getLogger('simManagement.reducers.orangeZonesReducer');

export default function mvnoTemplatesReducer(
  state: MvnoTemplatesState = initialAppState.mvnoTemplates,
  action: any,
): MvnoTemplatesState {
  switch (action.type) {
    case LOAD_MVNO_TEMPLATES_PENDING: {
      const accountId = action.payload as number;
      if (!accountId) {
        log.warn('No meta');
        return state;
      }

      return {
        all: [],
        allById: {},
        enabled: [],
        enabledById: {},
        isLoading: true,
      };
    }
    case LOAD_MVNO_TEMPLATES_FAILURE: {
      const error = action.payload as SimManagementError;
      if (!error) {
        log.warn('No payload');
        return state;
      }

      const accountId = action.meta as number;
      if (!accountId) {
        log.warn('No meta');
        return state;
      }

      return {
        all: [],
        allById: {},
        enabled: [],
        enabledById: {},
        isLoading: false,
        error,
      };
    }
    case LOAD_MVNO_TEMPLATES_SUCCESS: {
      const templates = action.payload as MvnoTemplate[];
      if (!templates) {
        log.warn('No payload');
        return state;
      }

      const all: DropdownItem[] = [];
      const enabled: DropdownItem[] = [];
      _.forEach(templates, (template) => {
        const item = {
          key: template.id,
          label: template.friendlyName,
        };

        all.push(item);
        enabled.push(item);
      });

      const newState: MvnoTemplatesState = {
        all: [...all],
        allById: Object.assign({}, ...all.map((a) => ({ [String(a.key)]: a }))),
        enabled: [...enabled],
        enabledById: Object.assign({}, ...enabled.map((a) => ({ [String(a.key)]: a }))),
        isLoading: false,
        expiresOn: moment().add(MvnoTemplatesCacheTimeout, 'seconds').toDate(),
        error: undefined,
      };

      return newState;
    }
    default:
      return state;
  }
}
